import { useState } from "react";
import "./faqservices.css";


const FaqServices = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(data.defaultOpen ?? 0);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container container">

        {/* Heading */}
        <div className="faq-heading">
          <span></span>
          <h2>{data.title}</h2>
        </div>

        {/* FAQs */}
        <div className="faq-list">
          {data.items.map((item, index) => {
            const isOpen = activeIndex === index;

            return (
              <div
                className={`faq-item ${isOpen ? "is-open" : ""}`}
                key={index}
              >
                <button
                  type="button"
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={isOpen}
                >
                  <span>{item.question}</span>

                  <span className="faq-icon">
                    {isOpen ? "−" : "+"}
                  </span>
                </button>

                <div
                  className="faq-answer"
                  style={{
                    maxHeight: isOpen ? "500px" : "0px",
                  }}
                >
                  <p>{item.answer}</p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}

export default FaqServices;